import { matchPath } from 'react-router-dom';

import { getProductRoute } from '../../organisations';
import { ROUTES, ROUTE_PARAMS, PREDICT_PRODUCT_SLUG } from '../../app-core';
import { joinRouteMatchUrl, joinRouteMatchPath, interpolatePathParams } from '../../path';

export * from './onboarding-routes-utils';
export * from './reporting-routes-utils';
export * from './dashboards-routes-utils';

export const getPredictForecastSalesNetUrl = (
  workspaceId: string,
  organisationId: string,
  forecastId: string
): string => {
  const productPath = getProductRoute();

  return interpolatePathParams(
    joinRouteMatchUrl('', productPath, ROUTES.FORECASTS, ROUTES.FORECAST_BY_ID, ROUTES.HOME, ROUTES.SALES),
    {
      [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId,
      [ROUTE_PARAMS.ORGANISATION_ID]: organisationId,
      [ROUTE_PARAMS.PRODUCT_SLUG]: PREDICT_PRODUCT_SLUG,
      [ROUTE_PARAMS.FORECAST_ID]: forecastId
    }
  );
};

export const getPredictForecastCostOfSalesNetUrl = (
  workspaceId: string,
  organisationId: string,
  forecastId: string
): string => {
  const productPath = getProductRoute();

  return interpolatePathParams(
    joinRouteMatchUrl('', productPath, ROUTES.FORECASTS, ROUTES.FORECAST_BY_ID, ROUTES.HOME, ROUTES.COST_OF_SALES),
    {
      [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId,
      [ROUTE_PARAMS.ORGANISATION_ID]: organisationId,
      [ROUTE_PARAMS.PRODUCT_SLUG]: PREDICT_PRODUCT_SLUG,
      [ROUTE_PARAMS.FORECAST_ID]: forecastId
    }
  );
};

export const getPredictForecastExpensesNetUrl = (
  workspaceId: string,
  organisationId: string,
  forecastId: string
): string => {
  const productPath = getProductRoute();

  return interpolatePathParams(
    joinRouteMatchUrl('', productPath, ROUTES.FORECASTS, ROUTES.FORECAST_BY_ID, ROUTES.HOME, ROUTES.EXPENSES),
    {
      [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId,
      [ROUTE_PARAMS.ORGANISATION_ID]: organisationId,
      [ROUTE_PARAMS.PRODUCT_SLUG]: PREDICT_PRODUCT_SLUG,
      [ROUTE_PARAMS.FORECAST_ID]: forecastId
    }
  );
};

export const getPredictForecastExpensesUrl = (
  workspaceId: string,
  organisationId: string,
  forecastId: string
): string => {
  const productPath = getProductRoute();

  return interpolatePathParams(
    joinRouteMatchUrl('', productPath, ROUTES.FORECASTS, ROUTES.FORECAST_BY_ID, ROUTES.PREDICTIONS, ROUTES.EXPENSES),
    {
      [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId,
      [ROUTE_PARAMS.ORGANISATION_ID]: organisationId,
      [ROUTE_PARAMS.PRODUCT_SLUG]: PREDICT_PRODUCT_SLUG,
      [ROUTE_PARAMS.FORECAST_ID]: forecastId
    }
  );
};

export const getPredictForecastBalanceSheetUrl = (
  workspaceId: string,
  organisationId: string,
  forecastId: string
): string => {
  const productPath = getProductRoute();

  return interpolatePathParams(
    joinRouteMatchUrl(
      '',
      productPath,
      ROUTES.FORECASTS,
      ROUTES.FORECAST_BY_ID,
      ROUTES.PREDICTIONS,
      ROUTES.BALANCE_SHEET
    ),
    {
      [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId,
      [ROUTE_PARAMS.ORGANISATION_ID]: organisationId,
      [ROUTE_PARAMS.PRODUCT_SLUG]: PREDICT_PRODUCT_SLUG,
      [ROUTE_PARAMS.FORECAST_ID]: forecastId
    }
  );
};

export const getPredictForecastInvoicesUrl = (
  workspaceId: string,
  organisationId: string,
  forecastId: string
): string => {
  const productPath = getProductRoute();

  return interpolatePathParams(
    joinRouteMatchUrl('', productPath, ROUTES.FORECASTS, ROUTES.FORECAST_BY_ID, ROUTES.PREDICTIONS, ROUTES.INVOICES),
    {
      [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId,
      [ROUTE_PARAMS.ORGANISATION_ID]: organisationId,
      [ROUTE_PARAMS.PRODUCT_SLUG]: PREDICT_PRODUCT_SLUG,
      [ROUTE_PARAMS.FORECAST_ID]: forecastId
    }
  );
};

export const getPredictForecastCostsUrl = (workspaceId: string, organisationId: string, forecastId: string): string => {
  const productPath = getProductRoute();

  return interpolatePathParams(
    joinRouteMatchUrl('', productPath, ROUTES.FORECASTS, ROUTES.FORECAST_BY_ID, ROUTES.PREDICTIONS, ROUTES.COSTS),
    {
      [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId,
      [ROUTE_PARAMS.ORGANISATION_ID]: organisationId,
      [ROUTE_PARAMS.PRODUCT_SLUG]: PREDICT_PRODUCT_SLUG,
      [ROUTE_PARAMS.FORECAST_ID]: forecastId
    }
  );
};

export const getPredictForecastImportUrl = (
  workspaceId: string,
  organisationId: string,
  forecastId: string
): string => {
  const productPath = getProductRoute();

  return interpolatePathParams(
    joinRouteMatchUrl('', productPath, ROUTES.FORECASTS, ROUTES.FORECAST_BY_ID, ROUTES.IMPORT),
    {
      [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId,
      [ROUTE_PARAMS.ORGANISATION_ID]: organisationId,
      [ROUTE_PARAMS.PRODUCT_SLUG]: PREDICT_PRODUCT_SLUG,
      [ROUTE_PARAMS.FORECAST_ID]: forecastId
    }
  );
};

export const getPredictForecastSalesUrl = (workspaceId: string, organisationId: string, forecastId: string): string => {
  const productPath = getProductRoute();

  return interpolatePathParams(
    joinRouteMatchUrl('', productPath, ROUTES.FORECASTS, ROUTES.FORECAST_BY_ID, ROUTES.PREDICTIONS, ROUTES.SALES),
    {
      [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId,
      [ROUTE_PARAMS.ORGANISATION_ID]: organisationId,
      [ROUTE_PARAMS.PRODUCT_SLUG]: PREDICT_PRODUCT_SLUG,
      [ROUTE_PARAMS.FORECAST_ID]: forecastId
    }
  );
};

export const getPredictForecastFinancialsNetUrl = (
  workspaceId: string,
  organisationId: string,
  forecastId: string,
  financialDetailKind: string
): string => {
  const productPath = getProductRoute();

  return interpolatePathParams(
    joinRouteMatchUrl(
      '',
      productPath,
      ROUTES.FORECASTS,
      ROUTES.FORECAST_BY_ID,
      ROUTES.FINANCIALS,
      ROUTES.FINANCIAL_DETAIL_KIND
    ),
    {
      [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId,
      [ROUTE_PARAMS.ORGANISATION_ID]: organisationId,
      [ROUTE_PARAMS.PRODUCT_SLUG]: PREDICT_PRODUCT_SLUG,
      [ROUTE_PARAMS.FORECAST_ID]: forecastId,
      [ROUTE_PARAMS.FINANCIAL_DETAIL_KIND]: financialDetailKind
    }
  );
};

export const getPredictTrialExpiredUrl = (workspaceId: string, organisationId: string): string => {
  const productPath = getProductRoute();

  return interpolatePathParams(joinRouteMatchUrl('', productPath, ROUTES.TRIAL_EXPIRED), {
    [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId,
    [ROUTE_PARAMS.ORGANISATION_ID]: organisationId,
    [ROUTE_PARAMS.PRODUCT_SLUG]: PREDICT_PRODUCT_SLUG
  });
};

export const getPredictSyncingProgressUrl = (workspaceId: string, organisationId: string): string => {
  const productPath = getProductRoute();

  return interpolatePathParams(joinRouteMatchUrl('', productPath, ROUTES.SYNCING_PROGRESS), {
    [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId,
    [ROUTE_PARAMS.ORGANISATION_ID]: organisationId,
    [ROUTE_PARAMS.PRODUCT_SLUG]: PREDICT_PRODUCT_SLUG
  });
};

/**
 * Checks whether the location passed as parameter matches with the syncing progress page path.
 * @param {string} pathname
 * @returns {match|null}
 */
export const matchPredictSyncingProgressPath = (pathname: string): ReturnType<typeof matchPath> => {
  const productPath = getProductRoute();

  return matchPath({ path: `${productPath}${ROUTES.SYNCING_PROGRESS}`, end: false }, pathname);
};

/**
 * Checks whether the location passed as parameter matches with the predict performance page path.
 * @param {string} pathname
 * @returns {match|null}
 */
export const matchPredictPerformancePagePath = (pathname: string): ReturnType<typeof matchPath> => {
  const productPath = getProductRoute();
  const path = [productPath, ROUTES.FORECASTS, ROUTES.FORECAST_BY_ID, ROUTES.PERFORMANCE].join('');
  return matchPath({ path: `${path}/*`, end: true }, pathname);
};

/**
 * Checks whether the location passed as parameter matches with the predict predictions page path.
 * @param {string} pathname
 * @returns {match|null}
 */
export const matchPredictPredictionsPagePath = (pathname: string): ReturnType<typeof matchPath> => {
  const productPath = getProductRoute();
  const path = [productPath, ROUTES.FORECASTS, ROUTES.FORECAST_BY_ID, ROUTES.PREDICTIONS].join('');
  return matchPath({ path: `${path}/*`, end: true }, pathname);
};

export const matchPredictNonFinancialDriversPagePath = (pathname: string): ReturnType<typeof matchPath> => {
  const productPath = getProductRoute();
  const path = [productPath, ROUTES.NON_FINANCIAL_DRIVERS].join('');
  return matchPath({ path: `${path}/*`, end: true }, pathname);
};

export const matchPredictSettingsPath = (pathname: string): ReturnType<typeof matchPath> => {
  const path = getPredictSettingsRoute();
  return matchPath({ path: `${path}/*` }, pathname);
};

export const matchPredictForecastingPath = (pathname: string): ReturnType<typeof matchPath> => {
  const path = getForecastingRoute();
  return matchPath({ path: `${path}/*` }, pathname);
};

export const getPredictSettingsOrganisationsPath = () =>
  joinRouteMatchPath(
    ROUTES.ROOT_ROUTE,
    ROUTES.WORKSPACES_ROUTE,
    ROUTES.WORKSPACE_BY_ID_ROUTE,
    ROUTES.WORKSPACE_BY_ID_SETTINGS_ROUTE,
    ROUTES.ORGANISATIONS_ROUTE,
    ROUTES.CONSOLIDATION_TAB
  );

export const matchPredictSettingsOrganisationsPath = (pathname: string) => {
  // Create explicit patterns to match
  const basePattern = joinRouteMatchPath(
    ROUTES.WORKSPACES_ROUTE,
    ROUTES.WORKSPACE_BY_ID_ROUTE,
    ROUTES.WORKSPACE_BY_ID_SETTINGS_ROUTE,
    ROUTES.ORGANISATIONS_ROUTE
  );
  const withTabPattern = `${basePattern}/:tabId`;
  const withExtraPattern = `${basePattern}/*`;

  return (
    matchPath({ path: basePattern }, pathname) ||
    matchPath({ path: withTabPattern }, pathname) ||
    matchPath({ path: withExtraPattern }, pathname)
  );
};

export const getPredictSettingsUsersPath = () =>
  joinRouteMatchPath(
    '',
    ROUTES.ROOT_ROUTE,
    ROUTES.WORKSPACES_ROUTE,
    ROUTES.WORKSPACE_BY_ID_ROUTE,
    ROUTES.WORKSPACE_BY_ID_SETTINGS_ROUTE,
    ROUTES.USERS_ROUTE
  );

export const matchPredictSettingsUsersPath = (pathname: string) => {
  const path = getPredictSettingsUsersPath();
  return matchPath({ path: `${path}/*` }, pathname);
};

export const getPredictSettingsAccountPath = () =>
  joinRouteMatchPath(
    '',
    ROUTES.ROOT_ROUTE,
    ROUTES.WORKSPACES_ROUTE,
    ROUTES.WORKSPACE_BY_ID_ROUTE,
    ROUTES.WORKSPACE_BY_ID_SETTINGS_ROUTE,
    ROUTES.ACCOUNT_ROUTE
  );

export const getPredictPerformancePagePath = (): string => {
  const productPath = getProductRoute();

  return joinRouteMatchUrl('', productPath, ROUTES.FORECASTS, ROUTES.FORECAST_BY_ID, ROUTES.PERFORMANCE);
};

export const getPredictPredictionsPagePath = (): string => {
  const productPath = getProductRoute();

  return joinRouteMatchUrl('', productPath, ROUTES.FORECASTS, ROUTES.FORECAST_BY_ID, ROUTES.PREDICTIONS);
};

export const getNonFinancialDriversPagePath = (): string => {
  const productPath = getProductRoute();
  const path = joinRouteMatchPath('', productPath, ROUTES.NON_FINANCIAL_DRIVERS);
  return path;
};

export const getHomePagePath = (): string => {
  const productPath = getProductRoute();
  const path = joinRouteMatchPath('', productPath, ROUTES.HOME);
  return path;
};

export const getPredictPerformancePageUrl = (workspaceId: string, organisationId: string, forecastId: string): string =>
  interpolatePathParams(getPredictPerformancePagePath(), {
    [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId,
    [ROUTE_PARAMS.ORGANISATION_ID]: organisationId,
    [ROUTE_PARAMS.PRODUCT_SLUG]: PREDICT_PRODUCT_SLUG,
    [ROUTE_PARAMS.FORECAST_ID]: forecastId
  });

export const getPredictNonFinancialDriversUrl = (workspaceId: string, organisationId: string): string => {
  return interpolatePathParams(getNonFinancialDriversPagePath(), {
    [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId,
    [ROUTE_PARAMS.ORGANISATION_ID]: organisationId,
    [ROUTE_PARAMS.PRODUCT_SLUG]: PREDICT_PRODUCT_SLUG
  });
};

export const getHomePageUrl = (workspaceId: string, organisationId: string): string => {
  return interpolatePathParams(getHomePagePath(), {
    [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId,
    [ROUTE_PARAMS.ORGANISATION_ID]: organisationId,
    [ROUTE_PARAMS.PRODUCT_SLUG]: PREDICT_PRODUCT_SLUG
  });
};

export const getPredictPerformanceSubpageUrl = (
  workspaceId: string,
  organisationId: string,
  forecastId: string,
  performanceSubpage: string
): string =>
  joinRouteMatchUrl('', getPredictPerformancePageUrl(workspaceId, organisationId, forecastId), performanceSubpage);

export const getPredictPredictionsPageUrl = (workspaceId: string, organisationId: string, forecastId: string): string =>
  interpolatePathParams(getPredictPredictionsPagePath(), {
    [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId,
    [ROUTE_PARAMS.ORGANISATION_ID]: organisationId,
    [ROUTE_PARAMS.PRODUCT_SLUG]: PREDICT_PRODUCT_SLUG,
    [ROUTE_PARAMS.FORECAST_ID]: forecastId
  });

export const getPredictPredictionsSubpageUrl = (
  workspaceId: string,
  organisationId: string,
  forecastId: string,
  predictionsSubpage: string
): string =>
  joinRouteMatchUrl('', getPredictPredictionsPageUrl(workspaceId, organisationId, forecastId), predictionsSubpage);

export const getPredictSettingsRoute = (): string =>
  joinRouteMatchPath(
    '',
    ROUTES.ROOT_ROUTE,
    ROUTES.WORKSPACES_ROUTE,
    ROUTES.WORKSPACE_BY_ID_ROUTE,
    ROUTES.WORKSPACE_BY_ID_SETTINGS_ROUTE
  );

export const getForecastingRoute = (): string =>
  joinRouteMatchPath(
    '',
    ROUTES.ROOT_ROUTE,
    ROUTES.WORKSPACE_BY_ID,
    ROUTES.ORGANISATION_BY_ID,
    ROUTES.PREDICT,
    ROUTES.FORECASTS
  );

export const getForecastingRouteUrl = (workspaceId: string, organisationId: string): string => {
  return interpolatePathParams(joinRouteMatchUrl('', getForecastingRoute()), {
    [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId,
    [ROUTE_PARAMS.ORGANISATION_ID]: organisationId
  });
};

export const getForecastingByIdRouteUrl = (workspaceId: string, organisationId: string, forecastId: string): string => {
  return interpolatePathParams(joinRouteMatchUrl('', getForecastingRoute(), ROUTES.FORECAST_BY_ID), {
    [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId,
    [ROUTE_PARAMS.ORGANISATION_ID]: organisationId,
    [ROUTE_PARAMS.FORECAST_ID]: forecastId
  });
};

export const getPredictSettingsOrganisationsPageUrl = (workspaceId: string, tabId = '') => {
  const url = interpolatePathParams(getPredictSettingsOrganisationsPath(), {
    [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId,
    [ROUTE_PARAMS.TAB_ID]: tabId
  });

  return url.replace('/?', '').replace('?', '');
};

export const getPredictSettingsUsersPageUrl = (workspaceId: string): string =>
  interpolatePathParams(getPredictSettingsUsersPath(), {
    [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId
  });

export const getPredictSettingsAccountPageUrl = (workspaceId: string): string =>
  interpolatePathParams(getPredictSettingsAccountPath(), {
    [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId
  });
